export const headerActionTypes = {
  newEntityButtonClick: '[APP Header] - new entity button click',
  exportTableButtonClick: '[APP Header] - export table button click',
  exportData: '[APP Header] - export data',
};
